import axios from 'axios'
export default {
  // editor images
  async getEditorImages (params) {
    return await axios.get('/api/spa/v1/editor_images', params)
  },
  async getPost (params) {
    return await axios.get('/api/spa/v1/posts', params)
  },
  // news
  async getNews (params) {
    return await axios.get('/api/spa/v1/news', { params })
  },
  async getCategories () {
    return await axios.get('/api/spa/v1/category')
  },
  async insertNews (params) {
    return await axios.post('/api/spa/v1/news', params)
  },
  async updateNews (params) {
    return await axios.put('/api/spa/v1/news/' + params.id, params)
  },
  async getNewsById (id) {
    return await axios.get('/api/spa/v1/news/' + id)
  },
  async deleteNews (id) {
    return await axios.delete('/api/spa/v1/news/' + id)
  },
  async assignOrderPriority (params) {
    return await axios.put('/api/spa/v1/post/order', params)
  },
  // articles
  async getArticles (params) {
    // await this.sleep(2000)
    return await axios.get('/api/spa/v1/article', { params })
  },
  async getArticleById (id) {
    // await this.sleep(2000)
    return await axios.get('/api/spa/v1/article/' + id)
  },
  async insertArticle (params) {
    // await this.sleep(2000)
    return await axios.post('/api/spa/v1/article', params)
  },
  async deleteArticle (id) {
    return await axios.delete('/api/spa/v1/article/' + id)
  },
  async updateArticle (params) {
    // await this.sleep(2000)
    return await axios.put('/api/spa/v1/article/' + params.id, params)
  },

  // Headlines

  async updateHeadlineSortOrder (params) {
    return await axios.put('/api/spa/v1/headline/sort', params)
  },
  async getHeadlines (params) {
    return await axios.get('/api/spa/v1/headlines', { params })
  },
  async deleteHeadline (id) {
    return await axios.delete('/api/spa/v1/headline/' + id)
  },
  async getHeadlineById (id) {
    return await axios.get('/api/spa/v1/headline/' + id)
  },
  async updateHeadline (params) {
    return await axios.put('/api/spa/v1/headline/' + params.id, params)
  },
  async insertHeadline (params) {
    return await axios.post('/api/spa/v1/headline', params)
  },
  async sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  },
  // editorial
  async getEditorials (params) {
    return await axios.get('/api/spa/v1/editorial', { params })
  },
  async getEditorialById (id) {
    // await this.sleep(1500)
    return await axios.get('/api/spa/v1/editorial/' + id)
  },
  async insertEditorial (params) {
    return await axios.post('/api/spa/v1/editorial', params)
  },
  async deleteEditorial (id) {
    return await axios.delete('/api/spa/v1/editorial/' + id)
  },
  async updateEditorial (params) {
    return await axios.put('/api/spa/v1/editorial/' + params.id, params)
  }

}
